<template>
  <v-dialog id="image-viewer" v-model="showDialog" :max-width="`${maxWidth}px`" no-click-animation>
    <v-card>
      <v-card-title id="image-viewer-title" dark class="no-select pa-1">
        <v-spacer />
        <v-card-actions>
          <v-btn id="close-btn" fab icon dark flat @click=";(showDialog = false), $emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-title>
      <v-img v-if="imageSrc" :src="`${this.baseUrls.images}/${this.imageSrc}`" height="50%" />
      <v-card-text v-else style="padding-top:80px; padding-bottom:50px;">
        <p>
          <v-icon class="mx-1 red--text">broken_image</v-icon>
          <span class="title grey--text">{{ $t('Sorry, the image link is not available') }}</span>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'image-viewer',

  props: {
    imageViewerDialog: { type: Boolean, required: true },
    imageSrc: { required: true },
    maxWidth: { type: Number, required: false, default: 800 }
  },

  data() {
    return {
      showDialog: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.imageViewerDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  watch: {
    imageViewerDialog: {
      handler() {
        this.showDialog = this.imageViewerDialog
      }
    },

    showDialog: {
      handler() {
        if (!this.showDialog) {
          this.$emit('hidemodal')
        }
      }
    }
  }
}
</script>

<style scoped>
#image-viewer {
  position: relative;
  z-index: 9999 !important;
  max-height: 50vh !important;
}
#image-viewer-title {
  position: absolute;
  z-index: 100;
  width: 100%;
  background: transparent;
}
#image-viewer-title #close-btn {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.8);
}
#image-viewer-title #close-btn:hover,
#image-viewer-title #close-btn:focus {
  background: rgba(0, 0, 0, 0.6);
  border: 2px solid white;
}
</style>
